import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  container: {
    paddingTop: 0,
    backgroundColor: "#2C2C2E",
    width: "100%",
    borderBottomColor: "#32BFB1",
    borderBottomWidth: 2,
    paddingHorizontal: 25,
  },
  containerSubtitle: {
    paddingTop: 60,
    backgroundColor: "#2C2C2E",
    width: "100%",
    borderBottomColor: "#32BFB1",
    borderBottomWidth: 2,
    paddingHorizontal: 25,
  },
  content: {
    marginTop: 40,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  title: {
    color: "#fff",
    fontWeight: "bold",
    textAlign: "center",
    marginTop: 8,
  },
  titleAnIcon: {
    color: "#fff",
    fontWeight: "bold",
    textAlign: "center",
    width: "100%",
    marginTop: 8,
    marginLeft: -35,
  },
  iconsHeaderRight: {
    position: "relative",
    width: 22,
    height: 30,
    zIndex: 50
  },
  iconsHeader: {
    position: "relative",
    width: 22,
    height: 30,
    zIndex: 50
  },
  hrLine: {
    height: 0.5,
    width: "93%",
    position: "relative",
    borderWidth: 0.5,
    marginTop: 15,
    marginBottom: 10,
    borderColor: "#8E8E93",
    marginLeft: 14,
  },
  subtitle: {
    fontSize: 14,
    textAlign: "center",
    fontWeight: "500",
    color: "#8E8E93",
    paddingVertical: 15
  },
});

export default styles;
